import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import { useState, useEffect } from 'react';
import Modal from '../../helpers/Modal';
const TAG_FIELDS = [
    { key: 'pe_stamps_ordered', label: 'PE Stamps Ordered' },
    { key: 'pe_stamps_completed', label: 'PE Stamps Complete' },
    { key: 'op_package_ordered', label: 'Optimization Package Ordered' },
    { key: 'op_package_completed', label: 'Optimization Package Complete' },
];

export const ManageProjectTagsForm = ({ project }) => {
    const { token, base_url, setProjects } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tags, setTags] = useState({
        pe_stamps_ordered: false,
        pe_stamps_completed: false,
        op_package_ordered: false,
        op_package_completed: false,
    });

    useEffect(() => {
        if (isModalOpen) {
            setTags({
                pe_stamps_ordered: Boolean(project.pe_stamps_ordered),
                pe_stamps_completed: Boolean(project.pe_stamps_completed),
                op_package_ordered: Boolean(project.op_package_ordered),
                op_package_completed: Boolean(project.op_package_completed),
            });
        }
    }, [isModalOpen, project]);

    const handleTagChange = (key) => {
        setTags((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            const updated_project = await updateData(
                token,
                `${base_url}/apis/projects/${project.id}`,
                tags
            );

            if (updated_project.project) {
                setProjects((prevProjects) =>
                    prevProjects.map((p) =>
                        p.id === project.id ? updated_project.project : p
                    )
                );

                window.showAlert(200, 'Project tags updated successfully!');
                setIsModalOpen(false);
            }
        } catch (error) {
            console.error('Error updating project tags:', error);

            if (error.status === 404) {
                window.showAlert(404, 'Project not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid project data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to update project tags. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const manageProjectTagsForm = (
        <form onSubmit={handleSubmit}>
            <h2>Manage Project Tags</h2>
            <p><strong>Project: {project?.project_name}</strong></p>
            <p>Toggle stamp and optimization package tags for this project.</p>

            <div className="form-group">
                {TAG_FIELDS.map(({ key, label }) => (
                    <label key={key} className="checkbox-label checkbox-label--block">
                        <input
                            type="checkbox"
                            checked={tags[key]}
                            onChange={() => handleTagChange(key)}
                        />
                        {label}
                    </label>
                ))}
            </div>

            <div className="form-actions">
                <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="btn btn-secondary"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Saving...
                        </>
                    ) : (
                        'Save Tags'
                    )}
                </button>
            </div>
        </form>
    );

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className="btn btn-secondary"
                title="Manage Project Tags"
            >
                <FontAwesomeIcon icon={faTags} />
                &nbsp;
                Manage Project Tags
            </button>
            {isModalOpen && (
                <Modal form={manageProjectTagsForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
